import React from "react";
import { Button } from "@mui/material";

const CompanySelect = ({ registerClaim }) => {
  return (
    <>
      <Button style={
        {background: "#fff",
          padding: "0.75em",
          border: "1px solid #e6e6e6",
          color: "#1f323f"}
        }
        type="button"
        className="btn_primary"
        onClick={registerClaim} // Call registerClaim to make claim and clear input
        fullWidth
        variant="contained"
        sx={{ mt: 2, mb: 2 }}
      >
        Make a claim
      </Button>
    </>
  );
};

export default CompanySelect;
